import React from 'react';
import PropTypes from 'prop-types';
import IMAGES from 'modules/assets/web';

const Spinner = (props) => (
  <img
    className={`spinner ${props.classes} `}
    alt="loading"
    src={IMAGES.SPINNER}
  />
);

Spinner.propTypes = {
  classes: PropTypes.string,
};

Spinner.defaultProps = {
  classes: '',
};

export default Spinner;
